import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import LoginController from '@/assets/ts/controller/LoginController';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import TkField from '@/../bower_components/teknisavuecomponents/components/fields/TkField.vue';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import Messages from '@/assets/ts/utils/Messages';
import OperadorController from '@/assets/ts/controller/OperadorController';
import IntervalController from "@/assets/ts/controller/IntervalController";
import PopupController from "@/assets/ts/controller/PopupController";
import OfflineController from "@/assets/ts/controller/OfflineController";

@Component({
  name: 'ConfirmPassword',
  components: {
    TkField,
    TkForm,
  },
})
export default class ConfirmPassword extends Vue {
  // [ PROPS ]
  @Prop({ default: null})
  private name: string;

  @Prop({ default: (): any => null})
  private closeAction: () => void;

  @Prop({ default: () => {}})
  private defaultRow: any;

  @Prop({ default: false })
  private isVisible: boolean;

  @Prop({ default: false })
  private isNotClosePopup: boolean;
  // [ PROPS ]

  // [ DATA ]
  private tkForm: any = {
    row: {},
    loading: false,
  };

  private screen = {
    title: 'Confirme seu acesso para prosseguir',
  };

  private actions = {
    close: this.close,
    save: this.confirmPassword,
    saveDisabled: false,
  }
  // [ DATA ]

  // [ STORE ]
  @Getter('user')
  private user: any;
  
  @Mutation('controlPopUp')
  private controlPopUp: (popUp: {[key: string]: any, popUp: string}) => void;
  // [ STORE ]

  // [ COMPUTED ]
  private get fields(): Field[] {
    const f: Field[] = [
      {
        name: 'PASSWORD',
        label: 'Senha',
        size: 12,
        type: 'password',
        readonly: false,
        required: true,
      },
    ];

    return f;
  }
  // [ COMPUTED ]

  // [ EMIT ]
  @Emit('close-popup')
  private close() {
    this.tkForm.row = {};
  }
  // [ EMIT ]

  // [ METHODS ]
  @Watch('isVisible', { immediate: true, deep: true })
  private isVisibleOnChange(newValue: boolean) {
    if (newValue) {
      this.tkForm.row = { ...this.tkForm.row, ...this.defaultRow };
    }
  }

  private async confirmPassword() {
    if (!this.tkForm.row.validate()) {
      SnackbarUtils.showMessage(Messages.REQUIRED_FIELDS_NOT_FILLED, SnackbarUtils.TYPE_ALERT);
      return;
    }

    try {  
      const response = await LoginController.requestLogin(this.user.email ,this.tkForm.row.PASSWORD);
      if (response.data.error) {
        SnackbarUtils.showMessage(Messages.LOGIN_INCORRECT, SnackbarUtils.TYPE_ERROR);

        if(this.isNotClosePopup) {
          this.lidarComErroDeSenhaComTrava();
        }

        return;
      }
    } catch(e) {
      this.lidarComErroDeSenhaComTrava();
      SnackbarUtils.showMessage(Messages.LOGIN_FAIL, SnackbarUtils.TYPE_ERROR);
    }

    try {

      if(this.isNotClosePopup) {
        this.closePopupManual();
        return;
      }

      await OperadorController.removeRestricaoApenasMarcacaoPG();
      IntervalController.cancelRPUIntervalReload();
      LoginController.redirectToDefaultPage();

      if(OfflineController.checkIsOffline()) {
        OfflineController.setOnline();
      }

      this.actions.close();
    } catch(e) {
      SnackbarUtils.showMessage(Messages.REGISTRO_RESTRICTION_CONFIRMATION_FAIL, SnackbarUtils.TYPE_ERROR);
    }
  }

  private beforeRequest() {
    this.tkForm.loading = true;
    this.actions.saveDisabled = true;
  }

  private afterRequest() {
    this.tkForm.loading = false;
    this.actions.saveDisabled = false;
  }

  private closePopupManual () {
    this.tkForm.row = {};
    PopupController.closePopup('confirmPassword');
  }

  private lidarComErroDeSenhaComTrava () {
    this.$router.push('/registroPonto');
    this.closePopupManual();
  }

  // [ METHODS ]
}